import React from 'react';
import { Box, Typography } from '@mui/material';
import './CameraConnectionStatus.css';

/**
 * CameraConnectionStatus Component
 * Displays connection status for each camera with green/red indicators
 */
const CameraConnectionStatus = ({ cameras }) => {
    if (!cameras || cameras.length === 0) {
        return (
            <Box className="camera-connection-container">
                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                    Čekanje na kamere...
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="camera-connection-container">
            {cameras.map((camera) => (
                <Box
                    key={camera.id}
                    className="camera-status-item"
                    title={`Poslednji heartbeat: ${camera.lastHeartbeat ? new Date(camera.lastHeartbeat).toLocaleString('sr-RS') : 'Nikad'}`}
                >
                    <span
                        className={`status-dot ${camera.isConnected ? 'connected' : 'disconnected'}`}
                    />
                    <Typography variant="body2" className="camera-label">
                        {camera.id || camera.ip || 'Nepoznata kamera'}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default CameraConnectionStatus;
